RivalIQ.module('views', function (views, Admin, Backbone, Marionette, $, _) {

    'use strict';

    const EmptyEmailInput = Marionette.ItemView.extend({
        template: '#emailEmptyItemTemplate'
    });

    const EmailInputItem = Marionette.ItemView.extend({
        template: '#emailInputItemTemplate',
        tagName: 'tr',

        ui: {
            removeLink: '.x-remove'
        },

        events: {
            'click @ui.removeLink': 'removeEmail'
        },

        removeEmail: function () {
            const me = this;
            me.model.collection.remove(me.model);
        }
    });

    views.EmailInput = Marionette.CompositeView.extend({
        template: '#emailInputTemplate',
        childView: EmailInputItem,
        childViewContainer: '.x-email-container',
        emptyView: EmptyEmailInput,

        collectionEvents: {
            'add': 'resetInput',
            'add:malformed': 'onMalformedAdd',
            'add:duplicate': 'resetInput'
        },

        ui: {
            table: '.x-email-table',
            input: '.x-email-input',
            saveBtn: '.x-add-email',
            error: '.x-validation-msg'
        },

        eventsNotToDebounce: {
            'click @ui.saveBtn': 'addEmail',
            'keydown @ui.input': 'onEmailKeydown'
        },

        templateHelpers: function () {
            const me = this;
            const prefix = me.getOption('namePrefix');

            return {
                name: (prefix ? `${prefix}[email]` : 'email')
            };
        },

        onEmailKeydown: function (e) {
            const me = this;

            if (e.keyCode === 13) {
                e.preventDefault();
                me.addEmail();
            }
        },

        onMalformedAdd: function () {
            const me = this;
            me.ui.error.show();
            me.ui.error.text(`Looks like that's not a valid email`);
        },

        resetInput: function () {
            const me = this;
            me.ui.input.val('');
            me.ui.error.hide();
        },

        addEmail: function () {
            const me = this;
            const email = $.trim(me.ui.input.val()).toLowerCase();
            me.collection.add({
                email: email
            }, {
                validate: true
            });
        }
    });
});
